<div smp-dropzone
     class="smp-drop-zone"
     [ngClass]="{ 'has-content': hasContent && !dragging, 'pb-2': !addButtonLabel, 'dragging-over': dragging }"
     (filesChangeEmitter)="onFilesChange($event)"
     (dragging)="onDragging($event)"
     [allowed_extensions]="acceptFilesArray">

  <a *ngIf="!hasContent"
     id="{{idPrefix}}btn.open_file_upload"
     class="centered-span iq-link-style"
     (click)="openFileUploadWindow()">
    {{ label }}
  </a>

  <div>
    <ng-content></ng-content>
  </div>

  <div *ngIf="addButtonLabel && hasContent"
       class="full-width div-add-attachment">
    <a id="{{idPrefix}}btn.open_file_upload_2"
       class="iq-link-style"
       (click)="openFileUploadWindow()">
      {{ addButtonLabel | translate }}
    </a>
  </div>

</div>

<input #fileUploadElement
       *ngIf="multi === false"
       type="file"
       accept="{{acceptedFilesString}}"
       (change)="onFilesChangeEvent($event)"
       style="display: none;"/>

<input #fileUploadElement
       *ngIf="multi !== false"
       type="file"
       accept="{{acceptedFilesString}}"
       (change)="onFilesChangeEvent($event)"
       style="display: none;"
       multiple />
